module.exports = __webpack_public_path__ + "img/doronFree.5eb22a7c.svg";